import {doStyleFooter} from "../blocks/footer";
import {doStyleNavigation} from "../blocks/navigation";
import {doStyleFixedBubbles} from "../blocks/fixedBubbles";
import {TranslationsManager} from "../utils/localisationManager";

export class AllPages {
    static EventListeners = {
        'ShoptetCartUpdated': AllPages.doLoadOnShoptetCartUpdated,
    }
    static doLoadOnShoptetCartUpdated() {
        if (!document.body.classList.contains("ordering-process")) {
            //TODO: This breaks badly
            //TODO: Create a custom method to preload the minicart view based upon this method. (AJAX)
            /*
            * @desc This method reloads the entire HTML of the #cart-wrapper clearing all the previous changes done to it
            * */
            shoptet.cart.getCartContent(false);
        }
    }
    static async doInit() {
        doStyleNavigation();
        AllPages.doStyleSharedBlocksWithOmissions();
        AllPages.doStyleAllMisc();
        return true;
    }

    static doStyleSharedBlocksWithOmissions() {
        if(!document.body.classList.contains('ordering-process')) {
            if(!document.body.classList.contains('type-index')) {
                // on other pages make the header fixed
                // $('#header').addClass('fixed');
            }
            doStyleFooter();
            doStyleFixedBubbles();

            AllPages.doSTyleStickyNavigation();
        }
    }
    static doStyleAllMisc() {
        // doStyleProductFlags();
        $('.dklab_instagram_widget_heading>.text').text(TranslationsManager.doGetStringByLang('INSTAGRAM_HEADER'));
    }

    static doSTyleStickyNavigation() {
        if($(window).width() > 767) {
            var $navigation = $('#navigation');
            var $sticky = $($navigation).offset().top+$navigation.outerHeight()+150;
            if($('body').height() > 2000) {
                window.onscroll = function doStickyNavigation() {
                    if(window.pageYOffset > $sticky){
                        $('body').addClass('navigation-is-sticky');
                    } else {
                        $('body').removeClass('navigation-is-sticky');
                    }
                }
            }
        }
    }
}
